// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hiddenText {
  display: none
}

.full-width {
  width: 50%
}

.side-margin {
  margin: 0 10px;
}

.padding {
  padding-bottom: 1em;
}

.style {
  width: 50%;
  display: block;
  height: 34px;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}

.upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  margin-bottom: 15px;
  float: left;
}

.ngx-datatable.bootstrap {
  box-shadow: none;
  font-size: 13px;
}

  .ngx-datatable.bootstrap .datatable-header {
    height: unset !important;
  }

    .ngx-datatable.bootstrap .datatable-header .datatable-header-cell {
      vertical-align: bottom;
      padding: 0rem 0.75rem;
      border-bottom: 1px solid #d1d4d7;
    }

      .ngx-datatable.bootstrap .datatable-header .datatable-header-cell .datatable-header-cell-label {
        line-height: 35px;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 11px;
        font-weight: bold;
        color: black;
      }

  .ngx-datatable.bootstrap .datatable-body {
  }

    .ngx-datatable.bootstrap .datatable-body .datatable-body-row {
      vertical-align: top;
      border-top: 1px solid #d1d4d7;
    }

      .ngx-datatable.bootstrap .datatable-body .datatable-body-row.datatable-row-even {
        /*background-color: rgba(0, 0, 0, 0.05); /* Commented out instead of removed in case this is desired in the future... */ 
      }

      .ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-cell {
        text-align: left;
        vertical-align: top;
      }

      .ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-cell-label {
        line-height: 160%;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 11px;
        color: black;
      }

      .ngx-datatable.bootstrap .datatable-body .datatable-body-row.active {
        background-color: #1483ff;
        color: #FFF;
      }

  .ngx-datatable.bootstrap .datatable-footer {
    background: #424242;
    color: #ededed;
    margin-top: 10px;
  }

    .ngx-datatable.bootstrap .datatable-footer .page-count {
      line-height: 50px;
      height: 50px;
      padding: 0 1.2rem;
    }

    .ngx-datatable.bootstrap .datatable-footer .datatable-pager {
      margin: 0 10px;
      vertical-align: top;
    }

      .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li {
        margin: 10px 0px;
      }

        .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled).active a,
        .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled):hover a {
          background-color: #545454;
          font-weight: bold;
        }

      .ngx-datatable.bootstrap .datatable-footer .datatable-pager a {
        height: 22px;
        min-width: 24px;
        line-height: 22px;
        padding: 0;
        border-radius: 3px;
        margin: 0 3px;
        text-align: center;
        vertical-align: top;
        text-decoration: none;
        vertical-align: bottom;
        color: white;
        background: #003b5c;
      }

      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-left,
      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-skip,
      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-right,
      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-prev {
        font-size: 18px;
        line-height: 27px;
        padding: 0 3px;
      }

[data-icon]:before {
  font-family: "data-table" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^="datatable-icon-"]:before,
[class*=" datatable-icon-"]:before {
  height: 22px;
  min-width: 24px;
  line-height: 22px;
  padding: 0;
  border-radius: 3px;
  margin: 0 3px;
  text-align: center;
  vertical-align: top;
  text-decoration: none;
  color: #000000;
}

.datatable-icon-filter:before {
  content: "\\62";
}

.datatable-icon-collapse:before {
  content: "\\61";
}

.datatable-icon-expand:before {
  content: "\\63";
}

.datatable-icon-close:before {
  content: "\\64";
}

.datatable-icon-up:before {
  content: "\\65";
}

.datatable-icon-down:before {
  content: "\\66";
}

.datatable-icon-sort:before {
  content: "\\67";
}

.datatable-icon-done:before {
  content: "\\68";
}

.datatable-icon-done-all:before {
  content: "\\69";
}

.datatable-icon-search:before {
  content: "\\6a";
}

.datatable-icon-pin:before {
  content: "\\6b";
}

.datatable-icon-add:before {
  content: "\\6d";
}

.datatable-icon-left:before {
  content: "\\<";
}

.datatable-icon-right:before {
  content: "\\>";
}

.datatable-icon-skip:before {
  content: "\\>>";
}

.datatable-icon-prev:before {
  content: "\\<<";
}

.table-panel {
  padding-top: 20px;
  margin-bottom: 0px;
  padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/core/dynamic-form-components/table-builder/table-builder.component.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,qEAAyG;AAC3G;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;EAEE;IACE,wBAAwB;EAC1B;;IAEE;MACE,sBAAsB;MACtB,qBAAqB;MACrB,gCAAgC;IAClC;;MAEE;QACE,iBAAiB;QACjB,kDAAkD;QAClD,eAAe;QACf,iBAAiB;QACjB,YAAY;MACd;;EAEJ;EACA;;IAEE;MACE,mBAAmB;MACnB,6BAA6B;IAC/B;;MAEE;QACE,uHAAuH;MACzH;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;MACrB;;MAEA;QACE,iBAAiB;QACjB,kDAAkD;QAClD,eAAe;QACf,YAAY;MACd;;MAEA;QACE,yBAAyB;QACzB,WAAW;MACb;;EAEJ;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;IAEE;MACE,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,cAAc;MACd,mBAAmB;IACrB;;MAEE;QACE,gBAAgB;MAClB;;QAEE;;UAEE,yBAAyB;UACzB,iBAAiB;QACnB;;MAEF;QACE,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,UAAU;QACV,kBAAkB;QAClB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,qBAAqB;QACrB,sBAAsB;QACtB,YAAY;QACZ,mBAAmB;MACrB;;MAEA;;;;QAIE,eAAe;QACf,iBAAiB;QACjB,cAAc;MAChB;;AAEN;EACE,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".hiddenText {\r\n  display: none\r\n}\r\n\r\n.full-width {\r\n  width: 50%\r\n}\r\n\r\n.side-margin {\r\n  margin: 0 10px;\r\n}\r\n\r\n.padding {\r\n  padding-bottom: 1em;\r\n}\r\n\r\n.style {\r\n  width: 50%;\r\n  display: block;\r\n  height: 34px;\r\n  color: #555;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\r\n  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;\r\n}\r\n\r\n.upload {\r\n  border: 1px solid #ccc;\r\n  display: inline-block;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n  margin-bottom: 15px;\r\n  float: left;\r\n}\r\n\r\n.ngx-datatable.bootstrap {\r\n  box-shadow: none;\r\n  font-size: 13px;\r\n}\r\n\r\n  .ngx-datatable.bootstrap .datatable-header {\r\n    height: unset !important;\r\n  }\r\n\r\n    .ngx-datatable.bootstrap .datatable-header .datatable-header-cell {\r\n      vertical-align: bottom;\r\n      padding: 0rem 0.75rem;\r\n      border-bottom: 1px solid #d1d4d7;\r\n    }\r\n\r\n      .ngx-datatable.bootstrap .datatable-header .datatable-header-cell .datatable-header-cell-label {\r\n        line-height: 35px;\r\n        font-family: Verdana, Arial, Helvetica, sans-serif;\r\n        font-size: 11px;\r\n        font-weight: bold;\r\n        color: black;\r\n      }\r\n\r\n  .ngx-datatable.bootstrap .datatable-body {\r\n  }\r\n\r\n    .ngx-datatable.bootstrap .datatable-body .datatable-body-row {\r\n      vertical-align: top;\r\n      border-top: 1px solid #d1d4d7;\r\n    }\r\n\r\n      .ngx-datatable.bootstrap .datatable-body .datatable-body-row.datatable-row-even {\r\n        /*background-color: rgba(0, 0, 0, 0.05); /* Commented out instead of removed in case this is desired in the future... */ \r\n      }\r\n\r\n      .ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-cell {\r\n        text-align: left;\r\n        vertical-align: top;\r\n      }\r\n\r\n      .ngx-datatable.bootstrap .datatable-body .datatable-body-row .datatable-body-cell-label {\r\n        line-height: 160%;\r\n        font-family: Verdana, Arial, Helvetica, sans-serif;\r\n        font-size: 11px;\r\n        color: black;\r\n      }\r\n\r\n      .ngx-datatable.bootstrap .datatable-body .datatable-body-row.active {\r\n        background-color: #1483ff;\r\n        color: #FFF;\r\n      }\r\n\r\n  .ngx-datatable.bootstrap .datatable-footer {\r\n    background: #424242;\r\n    color: #ededed;\r\n    margin-top: 10px;\r\n  }\r\n\r\n    .ngx-datatable.bootstrap .datatable-footer .page-count {\r\n      line-height: 50px;\r\n      height: 50px;\r\n      padding: 0 1.2rem;\r\n    }\r\n\r\n    .ngx-datatable.bootstrap .datatable-footer .datatable-pager {\r\n      margin: 0 10px;\r\n      vertical-align: top;\r\n    }\r\n\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li {\r\n        margin: 10px 0px;\r\n      }\r\n\r\n        .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled).active a,\r\n        .ngx-datatable.bootstrap .datatable-footer .datatable-pager ul li:not(.disabled):hover a {\r\n          background-color: #545454;\r\n          font-weight: bold;\r\n        }\r\n\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager a {\r\n        height: 22px;\r\n        min-width: 24px;\r\n        line-height: 22px;\r\n        padding: 0;\r\n        border-radius: 3px;\r\n        margin: 0 3px;\r\n        text-align: center;\r\n        vertical-align: top;\r\n        text-decoration: none;\r\n        vertical-align: bottom;\r\n        color: white;\r\n        background: #003b5c;\r\n      }\r\n\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-left,\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-skip,\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-right,\r\n      .ngx-datatable.bootstrap .datatable-footer .datatable-pager .datatable-icon-prev {\r\n        font-size: 18px;\r\n        line-height: 27px;\r\n        padding: 0 3px;\r\n      }\r\n\r\n[data-icon]:before {\r\n  font-family: \"data-table\" !important;\r\n  content: attr(data-icon);\r\n  font-style: normal !important;\r\n  font-weight: normal !important;\r\n  font-variant: normal !important;\r\n  text-transform: none !important;\r\n  speak: none;\r\n  line-height: 1;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n[class^=\"datatable-icon-\"]:before,\r\n[class*=\" datatable-icon-\"]:before {\r\n  height: 22px;\r\n  min-width: 24px;\r\n  line-height: 22px;\r\n  padding: 0;\r\n  border-radius: 3px;\r\n  margin: 0 3px;\r\n  text-align: center;\r\n  vertical-align: top;\r\n  text-decoration: none;\r\n  color: #000000;\r\n}\r\n\r\n.datatable-icon-filter:before {\r\n  content: \"\\62\";\r\n}\r\n\r\n.datatable-icon-collapse:before {\r\n  content: \"\\61\";\r\n}\r\n\r\n.datatable-icon-expand:before {\r\n  content: \"\\63\";\r\n}\r\n\r\n.datatable-icon-close:before {\r\n  content: \"\\64\";\r\n}\r\n\r\n.datatable-icon-up:before {\r\n  content: \"\\65\";\r\n}\r\n\r\n.datatable-icon-down:before {\r\n  content: \"\\66\";\r\n}\r\n\r\n.datatable-icon-sort:before {\r\n  content: \"\\67\";\r\n}\r\n\r\n.datatable-icon-done:before {\r\n  content: \"\\68\";\r\n}\r\n\r\n.datatable-icon-done-all:before {\r\n  content: \"\\69\";\r\n}\r\n\r\n.datatable-icon-search:before {\r\n  content: \"\\6a\";\r\n}\r\n\r\n.datatable-icon-pin:before {\r\n  content: \"\\6b\";\r\n}\r\n\r\n.datatable-icon-add:before {\r\n  content: \"\\6d\";\r\n}\r\n\r\n.datatable-icon-left:before {\r\n  content: \"\\<\";\r\n}\r\n\r\n.datatable-icon-right:before {\r\n  content: \"\\>\";\r\n}\r\n\r\n.datatable-icon-skip:before {\r\n  content: \"\\>>\";\r\n}\r\n\r\n.datatable-icon-prev:before {\r\n  content: \"\\<<\";\r\n}\r\n\r\n.table-panel {\r\n  padding-top: 20px;\r\n  margin-bottom: 0px;\r\n  padding-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
